import { Typography } from '@snack-uikit/typography';

import s from './MarketplaceNotFoundBlock.module.scss';

const MocksRu = {
  title: 'Ничего не найдено',
  description: 'Попробуйте изменить запрос',
};

export function MarketplaceNotFoundBlock() {
  return (
    <section data-qa="not-found" className={s.root}>
      <Typography.SansTitleL tag="h4">{MocksRu.title}</Typography.SansTitleL>
      <Typography.SansBodyM tag="p">{MocksRu.description}</Typography.SansBodyM>
    </section>
  );
}
